import { cn } from "@eisox/design-system";

interface DefectDotProps {
  defect?: boolean;
}

/** The health of the probe behind a reading, drawn inside its display, right of the value. */
const DefectDot: React.FC<DefectDotProps> = ({ defect }) =>
  defect === undefined ? null : (
    <span className={cn("size-2.5 rounded-full", defect ? "bg-primary-red" : "bg-primary-green")} />
  );

DefectDot.displayName = "DefectDot";

export { DefectDot };
export type { DefectDotProps };
